"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPeriodOfTheDayOf = exports.getPeriodOfTheDayOfPeriod = void 0;
const event_schema_1 = require("../types/global/event.schema");
const getPeriodOfTheDayOfPeriod = ({ startAt, endAt, }) => {
    return (0, exports.getPeriodOfTheDayOf)({
        start: startAt.getHours(),
        end: endAt.getHours(),
    });
};
exports.getPeriodOfTheDayOfPeriod = getPeriodOfTheDayOfPeriod;
const getPeriodOfTheDayOf = ({ start, end, }) => {
    return event_schema_1.workScheduleBetweenItems.find((i) => i.value && i.value.start === start && i.value.end === end);
};
exports.getPeriodOfTheDayOf = getPeriodOfTheDayOf;
